import TestimonialsProfessionals from "@/components/sections/testimonials-professionals";
import { TESTIMONIALS_FROM_PROFESSIONALS_TESTIMONIALS } from "@/lib/data";
import { Component } from "@builder.io/sdk";

export const testimonialsProfessionalsConfig: Component = {
  name: "Testimonials Professionals",
  inputs: [
    {
      name: "id",
      type: "string",
      defaultValue: "testimonials-professionals",
      helperText: "Unique identifier for the section",
      advanced: true,
    },
    {
      name: "heading",
      type: "string",
      defaultValue: "Testimonials from Professionals",
      helperText: "The main heading text displayed in the section",
    },
    {
      name: "showLogos",
      type: "boolean",
      defaultValue: true,
      helperText: "Whether to show the logos",
    },
    {
      name: "slides",
      type: "list",
      defaultValue: TESTIMONIALS_FROM_PROFESSIONALS_TESTIMONIALS,
      subFields: [
        {
          name: "videoUrl",
          type: "file",
          allowedFileTypes: ["mp4"],
          required: true,
          friendlyName: "Video URL",
          helperText: "URL of the testimonial video",
        },
        {
          name: "videoPreviewImage",
          type: "file",
          allowedFileTypes: ["jpeg", "png"],
          required: true,
          friendlyName: "Video Preview Image",
          helperText: "URL of the video thumbnail image",
        },
        {
          name: "name",
          type: "string",
          required: true,
          helperText: "Name of the person giving testimonial",
          friendlyName: "Name",
        },
        {
          name: "role",
          type: "string",
          required: true,
          helperText: "Professional title of the person",
          friendlyName: "Role",
        },
        {
          name: "quote",
          type: "string",
          required: true,
          helperText: "Text quote from the testimonial",
          friendlyName: "Quote",
        },
      ],
    },
  ],
};

export default TestimonialsProfessionals;
